﻿import React, { useEffect, useRef, useState } from 'react';

import { GMetrixInput } from 'components/GMetrixInput/GMetrixInput';
import { Badge, Button, Dropdown, Form } from 'react-bootstrap';
import { ToolTip } from 'components/ToolTip/ToolTip';
import { useIntl } from 'react-intl';

export interface GMetrixComboBoxListProps {
    className?: string;
    dataList: any[];
    disabled?: boolean;
    displayNameProp: string;
    displayNameSecondaryProp?: string;
    feedbackMessage?: string;
    infoTitle?: string;
    label?: string;
    selectedListItems?: any[];
    setDataList: (data: any) => any;
    subLabel?: string;
    validType?: 'invalid' | 'valid' | undefined;

}
export function GMetrixComboBoxList({ className, dataList, disabled, displayNameProp, displayNameSecondaryProp, feedbackMessage, infoTitle, label, selectedListItems = [], setDataList, subLabel, validType }: GMetrixComboBoxListProps) {

    const { formatMessage } = useIntl();
    const [query, setQuery] = useState('');
    const [selectedItems, setSelectedItems] = useState<any[]>([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const menuRef = useRef<any>();
    const filteredOptions = (dataList || []).filter(
        (option: any) => option[displayNameProp].toLowerCase().includes(query.toLowerCase()) &&
            !selectedItems.includes(option[displayNameProp])
    );

    useEffect(() => {

        setSelectedItems(selectedListItems);

    }, [selectedListItems]);

    const handleSelect = (item: any) => {

        setSelectedItems([...selectedItems, item]);
        setDataList([...selectedItems, item]);
        setQuery('');
        setShowDropdown(false);

    };
    const closeOpenMenus = (e: any) => {

        if (showDropdown && !menuRef.current?.contains(e.target)) {

            setShowDropdown(false);

        }

    };

    const removeItem = (item: any) => {

        setSelectedItems(selectedItems.filter(i => i !== item));
        setDataList(selectedItems.filter(i => i !== item));

    };
    document.addEventListener('mousedown', closeOpenMenus);

    return (
        <div className={className}>
            {label && (
                <div className="d-flex align-items-center">
                    <Form.Label className='fw-bold'>
                        {label}
                    </Form.Label>

                    {subLabel && (
                    <small className="text-muted ms-2 mb-2">
                        {subLabel}
                    </small>
                    )}
                    {infoTitle && <ToolTip className="mb-1" content={infoTitle} />}
                </div>
            )}

            <div className="position-relative">
                <div className="d-flex flex-wrap border rounded p-2">
                    {selectedItems.map((item, index) => (
                        <Badge pill bg="primary" className={`m-1 d-flex align-self-start${disabled ? ' opacity-75' : ''}`} key={index}>
                            <div className='me-2 ms-1' style={{ fontSize: '12px', lineHeight: 2.2 }}>
                                {item[displayNameProp] !== '' ? item[displayNameProp] : `No ${displayNameProp}`}
                                {' '}
                                {displayNameSecondaryProp && (
                                    <>
                                        {' '}
                                        {' '}
                                        {item[displayNameSecondaryProp] !== '' ? item[displayNameSecondaryProp] : `No ${displayNameSecondaryProp}`}
                                    </>
                                )}
                            </div>
                            <Button aria-label={`${formatMessage({ id: 'remove.d34ac1e7', defaultMessage: 'Remove' })} ${item[displayNameProp] ?? ''}`.trim()} className={'text-decoration-none text-white p-0'} disabled={disabled} onClick={() => removeItem(item)} variant={'link'}>
                                <i aria-hidden="true" className="ms-1 p-0 px-1 fa-thin fa-xmark fa-xl small">
                                </i>
                            </Button>
                        </Badge>
                    ))}
                    <GMetrixInput
                        onChange={e => {

                            setQuery(e.target.value);
                            setShowDropdown(true);

                        }}
                        className="border-0 shadow-none"
                        disabled={disabled}
                        feedbackMessage={feedbackMessage}
                        isInvalid={validType === 'invalid'}
                        isValid={validType === 'valid'}
                        onClick={() => setShowDropdown(true)}
                        onFocus={() => setShowDropdown(true)}
                        placeholder={formatMessage({ id: 'search_items.9f29e812', defaultMessage: 'Search items...' })}
                        style={{ flex: 1, maxHeight: 20, minWidth: 100 }}
                        validType={validType}
                        value={query}
                    />
                </div>

                {showDropdown && filteredOptions.length > 0 && (
                    <Dropdown.Menu show className="w-100 shadow" ref={menuRef}>
                        {filteredOptions.map((option: any, index: number) => (
                            <Dropdown.Item key={index} onClick={() => handleSelect(option)}>
                                {option[displayNameProp] !== '' ? option[displayNameProp] : `No ${displayNameProp}`}
                                {' '}
                                {displayNameSecondaryProp && (
                                    <>
                                        {' '}
                                        {option[displayNameSecondaryProp] !== '' ? option[displayNameSecondaryProp] : `No ${displayNameSecondaryProp}`}
                                    </>
                                )}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                )}
            </div>
        </div>

    );

}
